export const validateRefpadoSchema = json => {
  return true;
};
